module.exports = __webpack_public_path__ + "static/media/preloader-Big-DOMA-withText-Flood.c998819a.gif";